import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import CircularProgress from '@mui/material/CircularProgress'
import { useSelector, useDispatch } from 'react-redux'
import { download_file } from '../../../store/job/jobSlice'
import { formatDateTime, isAuth } from '../../../helpers/cookies'


const MessageCard = ({ job_id }) => {
  const { job_messages, sending_message } = useSelector((state) => state.job);
  const dispatch = useDispatch();

  const handleDownloadFile = async (fileKey) => {
    try {
      const action = await dispatch(
        download_file({ job_id: job_id, file_key: fileKey })
      );

      if (download_file.fulfilled.match(action)) {
        const url = action.payload.data.url;
        const link = document.createElement("a");
        link.href = url;
        link.click();
      } else {
        console.error("Failed to download file", action.payload);
      }
    } catch (err) {
      console.error("Download error:", err);
    }
  };

  const user = isAuth();

  const tempMessage = React.useMemo(() => {
    if (!sending_message) return null;

    const base = {
      user: {
        first_name: user?.first_name || '',
        last_name: user?.last_name || ''
      },
      log_datetime: new Date().toISOString(),
      isPending: true
    };

    if (sending_message.action_type === 1) {
      return {
        ...base,
        details: sending_message.message,
        attachment: sending_message.attachment ? sending_message.attachment.name : null
      };
    } else if (sending_message.action_type === 2) {
      return {
        ...base,
        prev_stage: { name: sending_message.prev_stage },
        new_stage: { name: sending_message.new_stage }
      };
    }
    return null;
  }, [sending_message, user]);

  const displayMessages = React.useMemo(() => {
    return tempMessage ? [tempMessage, ...job_messages] : job_messages;
  }, [tempMessage, job_messages]);

  return (
    <>
      {displayMessages.length > 0 && (
        displayMessages.map((message, index) => (
          <Box
            key={index}
            sx={{
              bgcolor: '#F5F5F5',
              py: 1,
              px: 1.5,
              mt: index === 0 ? 0 : 0.5,
              mb: 0.5,
              borderRadius: '10px',
              width: 'fit-content',
              maxWidth: '100%',
              opacity: message.isPending ? 0.6 : 1
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {message.isPending && (
                <CircularProgress size={12} sx={{ color: '#ff6100' }} />
              )}
              <Typography variant="subtitle2">
                Note by{" "}
                <strong>
                  {message.user?.first_name} {message.user?.last_name}
                </strong>{" "}
                - {formatDateTime(message.log_datetime)}
              </Typography>
            </Box>

            <Box>
              {(message.details || message.attachment) && (
                <>
                  {message.details && (
                    <Typography variant="subtitle2" sx={{ whiteSpace: 'pre-line' }}>
                      {message.details}
                    </Typography>
                  )}

                  {message.attachment && (
                    <Typography variant="subtitle2">
                      {message.isPending ? (
                        <span style={{ color: 'gray', fontStyle: 'italic' }}>
                          {message.attachment} (Uploading...)
                        </span>
                      ) : (
                        <span
                          onClick={() => handleDownloadFile(message.attachment)}
                          style={{
                            color: '#1204d6ff',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                          }}
                        >
                          {message.attachment.split('/').pop()}
                        </span>
                      )}
                    </Typography>
                  )}
                </>
              )}

              {(!message.details && !message.attachment) && (
                <Typography variant="subtitle2">
                  Status: {message.prev_stage?.name || "—"}
                  {message.new_stage ? ` → ${message.new_stage.name}` : ""}
                </Typography>
              )}
            </Box>
          </Box>
        ))
      )}
    </>
  );
}
export default MessageCard;
